/**
 * @see https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/guides/web-intent
 */
export const getShareOnTwitterUrl = (options: { post: string }) => {
  const url = new URL('https://twitter.com/intent/post');
  url.searchParams.append('text', options.post);

  return url.toString();
};
